
var SITE_URL;

SITE_URL = "https://app.leadlazarus.ai";
const ALLOW_ORIGIN = SITE_URL;

module.exports = { SITE_URL, ALLOW_ORIGIN };
